import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { ASSET_ICON } from "@/lib/api";

const Footer = ({ settings }) => {
  const { t, lang } = useLang();
  const wa = settings?.whatsapp_number || "919462550555";
  const inquiry = settings?.inquiry_number || "919462029820";

  return (
    <footer
      className="relative z-10 border-t border-[rgba(212,166,74,0.22)] mt-10"
      data-testid="site-footer"
    >
      <div className="container-narrow px-5 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img
            src={ASSET_ICON}
            alt="AstroDev"
            className="w-12 h-12 rounded-xl icon-halo"
          />
          <div className={lang === "hi" ? "font-devnagri" : ""}>
            <div className="gold-text font-display text-xl">{t.brandName}</div>
            <div className="text-xs tracking-widest uppercase font-sans-ui text-[color:var(--gold-soft)] opacity-80">
              {t.brandDomain}
            </div>
          </div>
        </div>

        <div className="text-center font-sans-ui text-sm text-[color:var(--gold-soft)] opacity-90">
          <div className="mb-1">{t.footerRights}</div>
          <div className="flex gap-4 justify-center">
            <a
              href={`https://wa.me/+${wa}`}
              className="link-underline hover:text-[color:var(--gold)]"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp"
            >
              +{wa}
            </a>
            <a
              href={`tel:+${inquiry}`}
              className="link-underline hover:text-[color:var(--gold)]"
              data-testid="footer-inquiry"
            >
              +{inquiry}
            </a>
          </div>
        </div>

        <div className="flex gap-3">
          <Link to="/admin" className="btn-ghost text-xs py-2 px-4" data-testid="footer-admin-link">
            {t.navAdmin}
          </Link>
          <Link to="/booking" className="btn-gold text-xs py-2 px-4" data-testid="footer-book-btn">
            {t.bookNow}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
